import Blazy from '../../../managers/blazy';

export default class {
  constructor(context) {
    // Set Context
    this._context = context;

    // Set State Values
    this._navLinks = this._context.querySelectorAll('[data-sub-link]');
    this._backLinks = this._context.querySelectorAll('[data-back]');
    this._initialSlide = this._context.querySelector('[data-slide]');
    this._featuredView = this._context.querySelector('[data-featured]');
    this._navLevel = 0;
    this._animationInterval = 700;

    // Initialise component
    this.init();
  }

  init() {
    // Add click listeners to links and check if exist
    if (this._navLinks.length > 0) {
      for (let navLink of this._navLinks) {
        navLink.addEventListener('click', event => this.toggleSubmenu(event));
      }
    }

    if (this._backLinks.length > 0) {
      for (let backLink of this._backLinks) {
        backLink.addEventListener('click', event => this.toggleBack(event));
      }
    }
  }

  toggleSubmenu(event) {
    event.preventDefault();
    let subMenu = event.target.parentNode.querySelector('[data-slide]');
    let subMenuContentHeight = event.target.parentNode.querySelector('[data-content]').offsetHeight;
    event.target.parentNode.parentNode.style.overflowY = "visible";
    let featuredContent = event.target.parentNode.querySelector('[data-submenu-content]').cloneNode(true);


    // If statement to prevent double clicks
    if (!subMenu.classList.contains('active')) {
      this.handleTransitionEvent();

      subMenu.classList.add('active');
      this._navLevel++;
      this.setSlideTransform();
      this._featuredView.innerHTML = featuredContent.innerHTML;

      let featuredContentHeight = this._featuredView.offsetHeight;
      let panelHeight = subMenuContentHeight < featuredContentHeight
        ? "auto"
        : "90svh";
      this._context.querySelector('.site-navigation__panel').style.height = panelHeight;
      const featuredContentImageHolders = [...this._featuredView.querySelectorAll('.site-navigation__imageHolder')];
      const imageHolderHiddenClass = 'site-navigation__imageHolder--hidden';
      const allFeaturedImagesHidden = featuredContentImageHolders.every(featuredContentImageHolder => featuredContentImageHolder.classList.contains(imageHolderHiddenClass));

      if (featuredContentImageHolders && allFeaturedImagesHidden) {
        featuredContentImageHolders.forEach(featuredContentImageHolder => {
          featuredContentImageHolder.classList.remove(imageHolderHiddenClass);
        });
        Blazy.revalidate();
      }
    }
  }

  toggleBack(event) {
    event.preventDefault();
    let subMenu = event.target.parentNode;

    if (subMenu.classList.contains("site-navigation__slide")) return this.closeDropdown(subMenu);

    let parentContainer = event.target;

    // We just have to go two levels up to find the correct content. 1 level up would be the content for itself.
    parentContainer = this.getParentContainer(parentContainer);
    parentContainer = this.getParentContainer(parentContainer.parentNode);


    let subMenuContentHeight = parentContainer.querySelector('[data-content]').offsetHeight;
    event.target.parentNode.parentNode.parentNode.removeAttribute("style");
    let featuredContent = parentContainer.querySelector('[data-submenu-content]').cloneNode(true);




    this._navLevel--;
    this.handleTransitionEvent();
    this.setSlideTransform();
    this._featuredView.innerHTML = featuredContent.innerHTML;

    let featuredContentHeight = this._featuredView.offsetHeight;
    let panelHeight = subMenuContentHeight < featuredContentHeight
      ? "auto"
      : "90svh";
    this._context.querySelector('.site-navigation__panel').style.height = panelHeight;

    Blazy.revalidate();
    subMenu.classList.remove('active');
  }

  setSlideTransform() {
    let transformClass = "translateX(-" + (this._navLevel * 100) + "%)";
    this._initialSlide.style.WebkitTransform = transformClass;
    this._initialSlide.style.msTransform = transformClass;
    this._initialSlide.style.transform = transformClass;
  }

  getParentContainer(el) {
    if (!el.hasAttribute("data-sub-menu")) {
      el = this.getParentContainer(el.parentNode);
    }
    return el;
  }

  handleTransitionEvent() {
    this._context.classList.add('keep-open');
    setTimeout(() => {
      document.addEventListener('mousemove', event => {
        this._context.classList.remove('keep-open');
      });
    }, this._animationInterval);
  }

  getDropdown(el) {
    if (!el.hasAttribute("data-component")) {
      el = this.getDropdown(el.parentNode);
    }
    return el;
  }

  closeDropdown(subMenu) {
    let dropdown = this.getDropdown(subMenu);
    dropdown.classList.remove('mobile-active');
  }
}
